import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  constructor(private httpClient: HttpClient) {
  }

  send(message: string): Observable<void> {
    return this.httpClient.post<any>(`/api/spelgemma.php/feedback`, { message });
  }
}
